import React, { useEffect, useState } from 'react'
import { dataEstadosTotal } from '../../../services/PaginaRuta';

const ModalEstadosTotalTiempoCalcularMedia = () => {
  const [dataEstados, setdataEstados] = useState({
    resultados: {
      cirugia: 0,
      "ingreso a sala": 0,
      preparado: 0,
      recuperacion: 0
    },
    porcentajes: {
      cirugia: 0,
      "ingreso a sala": 0,
      preparado: 0,
      recuperacion: 0
    }
  });
  // Datos de ejemplo para la tabla
  

  useEffect(()=>{
    dataEstadosTotal().then((res)=>{
        // if(res.data){
          console.log(res.data)
          setdataEstados(res.data)
        // }
        
    })
  },[])

  return (
    <div className="container mx-auto mt-5">
      <div className="overflow-hidden shadow-lg rounded-lg">
        <table className="min-w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th scope="col" className="text-sm font-medium px-6 py-4 text-left">
                Ingreso a Sala
              </th>
              <th scope="col" className="text-sm font-medium px-6 py-4 text-left">
                Preparado
              </th>
              <th scope="col" className="text-sm font-medium px-6 py-4 text-left">
                Cirugía
              </th>
              <th scope="col" className="text-sm font-medium px-6 py-4 text-left">
                Recuperación
              </th>
            </tr>
          </thead>
          <tbody>
           
              <tr className='bg-gray-200'>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.resultados["ingreso a sala"]} Minutos</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.resultados.preparado} Minutos</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.resultados.cirugia} Minutos</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.resultados.recuperacion} Minutos</td>
              </tr>
              <tr className='bg-gray-100'>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.porcentajes["ingreso a sala"]}%</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.porcentajes.preparado}%</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.porcentajes.cirugia}%</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{dataEstados.porcentajes.recuperacion}%</td>
              </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalEstadosTotalTiempoCalcularMedia